// API配置
export const API_CONFIG = {
    // DeepSeek API配置
    DEEPSEEK: {
      API_KEY: process.env.REACT_APP_DEEPSEEK_API_KEY || '', // 从环境变量读取
      BASE_URL: 'https://api.deepseek.com/v1/chat/completions',
      MODEL: 'deepseek-chat'
    }
  };
  
  // 检查API密钥是否配置
  export const checkApiConfiguration = () => {
    const issues = [];
    
    if (!API_CONFIG.DEEPSEEK.API_KEY) {
      issues.push('DeepSeek API密钥未配置');
    }
    
    return {
      isValid: issues.length === 0,
      issues
    };
  };
  
  // 用于开发测试的默认配置
  export const DEV_CONFIG = {
    // 在开发环境下可以使用模拟数据
    USE_MOCK_AI: !API_CONFIG.DEEPSEEK.API_KEY,
    ENABLE_AI_ANALYSIS: true,
    ENABLE_QUESTION_GENERATION: true
  };